import { ButtonLoaderIcon } from "../../assets/icons";
import { useLoanOffer } from "../../contexts";
import { useStepper } from "../../views/LoanApplicationSteps/Stepper";
import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";
import { datadogRum } from "@datadog/browser-rum";

const LoanOfferForm = () => {
  const {
    state: {
      id,
      loading,
      loanApplicationId,
      shareholderId,
      stage,
      isMainApplicant,
      totalShareholders,
      distributionPartnerId,
      distributionPartnerName,
      companyName,
    },
  } = useLoanOffer();
  const { currentStep, steps } = useStepper();
  const postHog = usePostHog();

  useEffect(() => {
    if (!loading && loanApplicationId) {
      postHog.reset();
      postHog.identify(loanApplicationId, {
        loanApplicationId,
        ...(distributionPartnerId && { distributionPartnerId }),
        ...(distributionPartnerName && { distributionPartnerName }),
        ...(companyName && { companyName }),
        shareholderId,
      });
      datadogRum.clearUser();
      datadogRum.setUser({
        id,
        loanApplicationId,
        shareholderId,
        ...(distributionPartnerId && { distributionPartnerId }),
        ...(distributionPartnerName && { distributionPartnerName }),
        ...(companyName && { companyName }),
        entity: "Shareholder",
        microflow: "LOAN_OFFER",
      });
    }
  }, [loading, loanApplicationId]);

  useEffect(() => {
    if (!loading && loanApplicationId && currentStep) {
      postHog.capture(
        `Loan Offer Microflow: Moved to step ${steps[currentStep[0]].name}`,
        {
          shareholderId,
          loanApplicationId,
          stage,
          isMainApplicant,
          totalShareholders,
          $set: {
            ...(distributionPartnerId && { distributionPartnerId }),
            ...(distributionPartnerName && { distributionPartnerName }),
            ...(companyName && { companyName }),
          },
        }
      );
      datadogRum.addAction(
        `Loan Offer Microflow: Moved to step ${steps[currentStep[0]].name}`,
        {
          shareholderId,
          loanApplicationId,
          stage,
          isMainApplicant,
          totalShareholders,
          ...(distributionPartnerId && { distributionPartnerId }),
          ...(distributionPartnerName && { distributionPartnerName }),
          ...(companyName && { companyName }),
        }
      );
    }
  }, [currentStep, loanApplicationId, loading]);

  return (
    <>
      {loading ? (
        <div className="cx-animate-spin cx-text-brand-primary-regular cx-w-10 cx-h-10">
          <ButtonLoaderIcon width="100%" height="100%" />
        </div>
      ) : (
        steps[currentStep[0]].subSteps[currentStep[1]].component
      )}
    </>
  );
};

export default LoanOfferForm;
